import { APP_BRANDS, type AppBrand } from '../constants'

const JOINT_COMMITTEE_124_XXX = '124.'
const JOINT_COMMITTEE_FOR_CONSTRUCT = JOINT_COMMITTEE_124_XXX

interface AppBrandCompany {
  offers?: {
    committees?: {
      code?: string | null
    }[]
  }[]
}

export const isConstructCompany = (
  company: AppBrandCompany | null | undefined
): boolean => {
  return (
    company?.offers?.some(offer =>
      offer.committees?.some(committee =>
        committee.code?.startsWith(JOINT_COMMITTEE_FOR_CONSTRUCT)
      )
    ) ?? false
  )
}

export const getAppBrandFromCompany = (
  company: AppBrandCompany | null | undefined
): AppBrand => {
  return isConstructCompany(company)
    ? APP_BRANDS.BrickJobs
    : APP_BRANDS.VivaConnect
}
